module.exports = __webpack_public_path__ + "static/shoes_01-cad9594d1d921fc25c7788d7d0f18149.png";